import styled from 'styled-components';

export const AppContainer = styled.div`
  min-height: 100vh;
  background-color: ${props => props.bgColor};
  padding: 0;
  margin: 0;
  transition: background-color 0.3s ease;
`;

export const ContentWrapper = styled.div`
  padding: 20px 0;
  max-width: 100%;
  margin: 0 auto;
  background-color: ${props => props.bgColor};
  color: ${props => props.textColor};
  min-height: calc(100vh - 70px);
  transition: background-color 0.3s ease, color 0.3s ease;
`;
